<template>
  <div class="w-100 h-100 d-flex align-items-center justify-content-center">
    <img
      src="@assets/img/logo-lg--colored.png"
      alt="LimeIQ"
      width="401"
      height="120"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent } from '@vue/composition-api'

import store from '@store'
import { AuthenticationService, ProfileService, TokenService } from '@services'

export default defineComponent({
  name: 'VerifyLogin',
  async beforeRouteEnter(to, _, next) {
    AuthenticationService.magicLoggedin = true

    try {
      const accessToken = to.query.access_token || to.query.token || null
      const refreshToken = to.query.refresh_token || null

      // Remember an SSO login so logout can also end the Entra session
      // (see AppNavbar handleLogout). Otherwise the Entra session survives a
      // LimeIQ logout and silently re-authenticates the next login.
      if (to.query.sso) {
        window.localStorage.setItem('limeiq_sso_session', '1')
      }

      store.dispatch('setAccessToken', accessToken)
      store.dispatch('setRefreshToken', refreshToken)

      await TokenService.verifyToken(accessToken)
      await ProfileService.getInfo()

      const { redirect_to, download_report, report_id } = to.query || {}

      if (!!redirect_to) {
        next({
          name: redirect_to
        })
      } else if (!!download_report) {
        next({
          name: 'ExportLog',
          query: {
            download_report: download_report
          }
        })
      } else {
        const routeParams = {}

        if (!!report_id) {
          const encodedReportID = btoa(btoa(`${report_id}:report-id`))

          routeParams.report_id = encodedReportID
        }

        next({
          name: 'Dashboard',
          params: routeParams
        })
      }
    } catch (_) {
      Vue.prototype.$toasted.show('Token is invalid or expired.', {
        type: 'error'
      })

      store.dispatch('setAccessToken', null)
      store.dispatch('setRefreshToken', null)

      next({ name: 'Login' })
    }
  }
})
</script>
